
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/connect/[[...method]]",
      function () {
        return require("private-next-pages/connect/[[...method]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/connect/[[...method]]"])
      });
    }
  